import { GET_SAFETY_SETTINGS, GET_SAFETY_SETTINGS_DONE, GET_SAFETY_SETTINGS_ERR, SET_SAFETY_SETTINGS, SET_SAFETY_SETTINGS_DONE, SET_SAFETY_SETTINGS_ERR, RESET_SAFETY_SETTINGS } from './actionTypes';
export const getSafetySettings = () => ({
    type: GET_SAFETY_SETTINGS
});
export const doneGetSafetySettings = (data) => ({
    type: GET_SAFETY_SETTINGS_DONE,
    data
});
export const errorGetSafetySettings = (data) => ({
    type: GET_SAFETY_SETTINGS_ERR,
    data
});
export const setSafetySettings = (data) => ({
    type: SET_SAFETY_SETTINGS,
    data
});
export const doneSetSafetySettings = (data) => ({
    type: SET_SAFETY_SETTINGS_DONE,
    data
});
export const resetSafetySettings = () => ({
    type: RESET_SAFETY_SETTINGS
});
export const errorSetSafetySettings = (data) => ({
    type: SET_SAFETY_SETTINGS_ERR,
    data
});
//# sourceMappingURL=actionCreators.js.map